import { GroupedLocaleMessages } from "shared/i18n";

// prettier-ignore
const messages: GroupedLocaleMessages = {
  "nl": {
    terms: {
      search: "Zoeken",
      cancel: "Annuleren",
      save: "Opslaan",
      yes: "Ja",
      no: "Nee",
    },
    errors: {
      default: "Er is iets mis gegaan bij het ophalen van de data"
    }
  }
}

export default messages;
